/*
import { Core } from '@unseenco/taxi'
import csySlide from './transitions/csyslide'

const taxi = new Core({
	transitions: {
		slideLeft: csySlide,
	}
})


taxi.preload('/welcome', true)
taxi.preload('/offers', true)
taxi.preload('/account', true)
taxi.preload('/transactions', true)

// Transition from forms
taxi.addRoute('/', '/register', 'slideLeft')

const links = document.querySelectorAll('nav a')
const linksli = document.querySelectorAll('nav li')
const h1 = document.querySelector("h1")

taxi.on('NAVIGATE_IN', ({ to, trigger }) => {
 document.body.classList = to.page.body.classList
  
  h1.innerText = document.title
  
   for (let i = 0; i < links.length; i++) {
    const link = links[i]
	const linkli = linksli[i]

    // Clean class
    link.classList.remove('is-active', 'icon-animate')
	linkli.classList.remove('current-menu-item')


    // Active link
    if (link.href === location.href) {
      link.classList.add('is-active', 'icon-animate')
	  linkli.classList.add('current-menu-item')
    }
  }
})
*/

import Swup from 'swup';
import { gsap } from 'gsap'
import SplitType from 'split-type'





import SwupBodyClassPlugin from '@swup/body-class-plugin';
const swup = new Swup( {
	animateHistoryBrowsing: true,
	timeout: 3_000,
	containers: ['#swup', '#app-breadcrumb'],
	plugins: [new SwupBodyClassPlugin()]
	
	});


function init() {
  if (document.querySelector('#promobarcode')) {
    var promocode = jQuery('#promobarcode').data('barcode');
        JsBarcode("#promobarcode", promocode,
            {
                margin: 25,
                height: 105,
                width: 4,
                textMargin: 5
            });
  }
  if (document.querySelector('#barcode')) {
     var barcode = jQuery('#barcode').data('barcode');
        JsBarcode("#barcode", barcode ,
            {
                margin: 20,
              //  width:4,
                textMargin:5,
				height: 85,
				fontSize: 12
				
            });
  }
  if (document.querySelector('.tilt')) {
    var tiltedElements = document.querySelectorAll('.tilt');
  
  tiltedElements.forEach((element) => {
    element.allTilt();
  });
  }
  
  if (document.querySelector('h1.app-intro-header-word')) {
  const appHeaderWord = new SplitType('h1.app-intro-header-word', { types: 'words' })
const words = appHeaderWord.words
  gsap.fromTo(
  words,
  { 
    y: 100,
    opacity: 0
  },
  {
    y: 0,
    opacity: 1,
    stagger: 0.05,
    duration: 1,
	delay:0.3,
    ease: 'power4.out',
  }
)

  }
  
   if (document.querySelector('h1.app-intro-header')) {
const appHeader = new SplitType('h1.app-intro-header', { types: 'chars' })
const chars = appHeader.chars
gsap.fromTo(
  chars,
  { 
    y: 100,
    opacity: 0
  },
  {
    y: 0,
    opacity: 1,
    stagger: 0.05,
    duration: 1,
	delay:0.4,
    ease: 'power4.out',
  }
)

  }
  
if (document.querySelector('.form-wrap')) {
const submitButton = document.querySelector(".gform_button");
const formBody = document.querySelector(".content");
const formSpinner = document.querySelector("[spinner]");

// hide show on sumbit
submitButton.addEventListener("click", () => {
formSpinner.style.display = 'block';
formBody.style.filter = 'grayscale(1)';
});

  }
  
if (document.querySelector('[data-modal]')) {
const gForm = document.querySelector(".gform_wrapper");
const showButton = document.querySelector("[data-open-modal]");
const closeButton = document.querySelector("[data-close-modal]");
const modal = document.querySelector("[data-modal]");

// "Show the dialog" button opens the dialog modally
showButton.addEventListener("click", () => {
  modal.showModal();
  gForm.style.display = 'block';
});

// "Close" button closes the dialo
closeButton.addEventListener("click", () => {
  modal.close();
});


  }
  
  if (document.querySelector('li.gf_readonly')) {
 const readOnly = document.querySelector("li.gf_readonly input");

readOnly.setAttribute('readonly', '')

  }
  
}


function stripTrailingSlash(url)     {     
    return url.replace(/\/$/, "");
} 

swup.hooks.before('content:replace', function() {
    theUrl = stripTrailingSlash(window.location.pathname)
    $theCurrent = document.querySelectorAll('#handheld-menu .current-menu-item')
	
    $newCurrentLink = document.querySelectorAll('#handheld-menu a[href*="' + theUrl + '"]')

  if ($newCurrentLink.length > 0) {
    var $curPar = $newCurrentLink[0].closest('#handheld-menu .menu-item');
    if ($curPar) {
      $curPar.classList.add('current-menu-item');
      $curPar.classList.add('current_page_item');
    }
  }

  if ($theCurrent.length > 0) {
    $theCurrent[0].classList.remove('current-menu-item');
    $theCurrent[0].classList.remove('current_page_item');
  }

});


if (document.readyState === 'complete') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', () => init());
}
// Run after every additional navigation by swup
swup.hooks.on('page:view', () => init());












